import { createClient } from '@supabase/supabase-js'

const dbUrl : string = "https://hamrhjkkdekizaifnvmj.supabase.co"
const anonKey : string = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhhbXJoamtrZGVraXphaWZudm1qIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY2MjQ1MTk2NiwiZXhwIjoxOTc4MDI3OTY2fQ.vFvnVukW2iH7WuVg1U51JinLGXOxPTop4RE3kVKD_QE"

// Provide a custom schema. Defaults to "public".
const supabase = createClient(
  dbUrl,
  anonKey
)

export default supabase